import { render } from "./CorseFuturePage.vue?vue&type=template&id=2d3d057e&scoped=true"
import script from "./CorseFuturePage.vue?vue&type=script&lang=js"
export * from "./CorseFuturePage.vue?vue&type=script&lang=js"

import "./CorseFuturePage.vue?vue&type=style&index=0&id=2d3d057e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3d057e"]])

export default __exports__